const DashboardHome = () => {
  return (
    <div>
      <h2 className="mb-4 text-2xl font-semibold text-[#000000]">
        Përmbledhje
      </h2>

      <p className="text-[#a6a6a6]">
        Mirë se erdhe në panelin e administratorit.
      </p>
    </div>
  );
};

export default DashboardHome;
